var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none text-truncate gradient shadow",class:{
    'disable-events': _vm.disabled,
    'small-font': _vm.smallFont,
    'medium-font': _vm.mediumFont,
  },attrs:{"rounded":"","to":_vm.to,"width":_vm.width,"elevation":"2","height":_vm.height,"loading":_vm.loading,"color":"green","small":_vm.small}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-2 ",attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',{staticClass:"bold white--text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }